<template>
    <div>Pages</div>
</template>